/* eslint-disable import/prefer-default-export */

/* Checks if the entity has all required properties defined. */
const isValidEntity = entity => {
  if (!entity?.type || !entity?.id) return false;
  if (!['listing', 'agent', 'office'].includes(entity.type)) return false;
  if (Number.isNaN(entity.id)) return false;
  return true;
};

export {
  isValidEntity,
};
